import React, {useState} from "react";
import AddTrip from "../AddTrip";
import TripDetailsContent from "./TripDetailsContent";
import { useTripContext } from "./TripContext";
import "../../css/TripDetails.css";
import "../../css/TripDetailsDesktopRefinement.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import PriorityPopup from "./PriorityPopup";

const TripDetails = ({ activeSection = "registrations", sectionContent = null, mobileRoot = false }) => {
  const { tripData, updateTripDataByObject, error } = useTripContext();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [showPriorityPopup, setShowPriorityPopup] = useState(false);

  const goToSection = (section) => navigate(`/trips/${tripData.guid}/${section}`);
  const handleRegistrationsClick = () => goToSection("registrations");
  const handleInsuranceClick = () => goToSection("insurances");
  const handleAttendanceClick = () => goToSection("participants");
  const handleDiscordClick = () => goToSection("discord");
  const handleAccessClick = () => goToSection("access");
  const handleSummary = () => goToSection("summary");
  const handleVariantClick = (variantGuid) => navigate(`/trips/${tripData.guid}/variants/${variantGuid}`);

  const handlePriorityClick = () => setShowPriorityPopup(true);
  const handleClosePriorityPopup = () => setShowPriorityPopup(false);
  const isEditing = searchParams.get("edit") === "true";
  const handleEditClick = () => navigate(`/trips/${tripData.guid}?edit=true`);
  const handleCancelEdit = () => navigate(`/trips/${tripData.guid}`);

  if (error || !tripData) {
    return <div className="error">{error ? <p>Błąd: {error}</p> : <p>Nie znaleziono wycieczki lub brak dostępu do zasobu.</p>}</div>;
  }

  return (
    <div>
      {isEditing ? (
        <AddTrip initialData={tripData} onSaveTrip={(updatedTrip) => { updateTripDataByObject(updatedTrip); handleCancelEdit(); }} onCancelEdit={handleCancelEdit} />
      ) : (
        <>
          <TripDetailsContent
            onEditClick={handleEditClick}
            onVariantClick={handleVariantClick}
            onRegistrationsClick={handleRegistrationsClick}
            onAttendanceClick={handleAttendanceClick}
            onAccessClick={handleAccessClick}
            onInsuranceClick={handleInsuranceClick}
            onPriorityClick={handlePriorityClick}
            onSummaryClick={handleSummary}
            onDiscordClick={handleDiscordClick}
            tripGuid={tripData.guid}
            activeSection={activeSection}
            sectionContent={sectionContent}
            mobileRoot={mobileRoot}
          />
          {showPriorityPopup && <PriorityPopup onClose={handleClosePriorityPopup} tripGuid={tripData.guid} />}
        </>
      )}
    </div>
  );
};

export default TripDetails;
